import { UrlConstants } from "../url.constants";
export class ApiBuildingPlansConstants {
    static URL = UrlConstants.API_V2 + "BuildingPlans";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBuildingPlansApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateBuildingPlansInvoiceReport";
    static FUNCTION_SET_PROFESSIONAL_BODIES = "SetBuildingPlansProfessionalBodies";
    static FUNCTION_SET_PROPERTIES = "SetBuildingPlansProperties";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalBuildingPlansApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalBuildingPlansApplication";
    static FUNCTION_GET_MY_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS = "GetMyAFLAPortalBuildingPlansApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS = "GetAllAFLAPortalBuildingPlansApplications";
    static FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER = "VerifyResubmissionReferenceNumber";
    static FUNCTION_VERIFY_EXTENSION_REFERENCE_NUMBER = "VerifyExtensionReferenceNumber";
}
